import OfferTypes from './offer.types';

export const setOfferContactInfo = offerContactInfo => ({
    type: OfferTypes.SET_OFFER_CONTACT_INFO,
    payload: offerContactInfo
});

